export default [
  {
    path: "/applyCertify", // 入口
    name: "applyCertify",
    component: resolve =>
      require([
        "@/pages/weixinH5/wrongFlightCertify/applyCertify.vue"
      ], resolve),
    meta: { title: "航班不正常证明" }
  },
  {
    path: "/wrongFlightCertify/certifyInfo", // 航班信息
    name: "certifyInfo",
    component: resolve =>
      require(["@/pages/weixinH5/wrongFlightCertify/certifyInfo.vue"], resolve),
    meta: { title: "航班不正常证明" }
  },
  {
    path: "/wrongFlightCertify/emailAddress", // 填写邮箱
    name: "emailAddress",
    component: resolve =>
      require([
        "@/pages/weixinH5/wrongFlightCertify/emailAddress.vue"
      ], resolve),
    meta: { title: "航班不正常证明" }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/wrongFlightCertify.js